// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InfoStep_otr {
	display: flex;
	align-items: center;
	flex-direction: column;
	width: 100%;
}

.InfoStep_otr .logo_img_container {
	padding-top: 6.813rem;
	padding-bottom: 2.125rem;
}
.InfoStep_otr .logo_img {
	width: 340px;
	height: 100px;
	object-fit: contain;
}

.InfoStep_otr .action_otr {
	display: flex;
	align-items: center;
	flex-direction: column;
	gap: 16px;
}

.InfoStep_otr .theme_btn {
	text-transform: none;
	font-size: 16px;
	line-height: 20px;
	font-weight: 600;
	font-family: "Poppins", sans-serif;
	padding: 12px 18px;
	border-radius: 50px;
	-webkit-border-radius: 50px;
	-moz-border-radius: 50px;
	-ms-border-radius: 50px;
	-o-border-radius: 50px;
	box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.15);
	cursor: pointer;
	height: auto !important;
}

.InfoStep_otr .existing_btn,
.InfoStep_otr .existing_btn:hover {
	background: var(--primary-color) !important;
	border: 1px solid var(--primary-color) !important;
	color: var(--white-color) !important;
}

.InfoStep_otr .new_btn,
.InfoStep_otr .new_btn:hover {
	border: 1px solid var(--info-button-bg) !important;
	background: var(--info-button-bg) !important;
	color: var(--black-color) !important;
}

.pac-container {
	z-index: 100000000000000000;
}

.address-autofill {
	width: -webkit-fill-available;
	/* height: 45px; */
	padding: 14px 14px 12px 14px;
	font-family: Verdana, sans-serif;
	border-color: #d9d9d9;
	min-width: 0;
	background-color: #ffffff;
	background-image: none;
	border-width: 1px;
	border-style: solid;
	border-color: #d9d9d9;
	border-radius: 6px;
	transition: all 0.2s;
	color: rgba(0, 0, 0, 0.88);
	font-size: 14px;
	line-height: 1.5714285714285714;
}

.address-autofill:focus-within {
	border-color: var(--blue-input-border) !important;
}
`, "",{"version":3,"sources":["webpack://./src/Components/ClientInfo/ClientInfo.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,mBAAmB;CACnB,sBAAsB;CACtB,WAAW;AACZ;;AAEA;CACC,qBAAqB;CACrB,wBAAwB;AACzB;AACA;CACC,YAAY;CACZ,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,sBAAsB;CACtB,SAAS;AACV;;AAEA;CACC,oBAAoB;CACpB,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,kCAAkC;CAClC,kBAAkB;CAClB,mBAAmB;CACnB,2BAA2B;CAC3B,wBAAwB;CACxB,uBAAuB;CACvB,sBAAsB;CACtB,2CAA2C;CAC3C,eAAe;CACf,uBAAuB;AACxB;;AAEA;;CAEC,2CAA2C;CAC3C,iDAAiD;CACjD,oCAAoC;AACrC;;AAEA;;CAEC,kDAAkD;CAClD,4CAA4C;CAC5C,oCAAoC;AACrC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,6BAA6B;CAC7B,kBAAkB;CAClB,4BAA4B;CAC5B,gCAAgC;CAChC,qBAAqB;CACrB,YAAY;CACZ,yBAAyB;CACzB,sBAAsB;CACtB,iBAAiB;CACjB,mBAAmB;CACnB,qBAAqB;CACrB,kBAAkB;CAClB,oBAAoB;CACpB,0BAA0B;CAC1B,eAAe;CACf,+BAA+B;AAChC;;AAEA;CACC,iDAAiD;AAClD","sourcesContent":[".InfoStep_otr {\n\tdisplay: flex;\n\talign-items: center;\n\tflex-direction: column;\n\twidth: 100%;\n}\n\n.InfoStep_otr .logo_img_container {\n\tpadding-top: 6.813rem;\n\tpadding-bottom: 2.125rem;\n}\n.InfoStep_otr .logo_img {\n\twidth: 340px;\n\theight: 100px;\n\tobject-fit: contain;\n}\n\n.InfoStep_otr .action_otr {\n\tdisplay: flex;\n\talign-items: center;\n\tflex-direction: column;\n\tgap: 16px;\n}\n\n.InfoStep_otr .theme_btn {\n\ttext-transform: none;\n\tfont-size: 16px;\n\tline-height: 20px;\n\tfont-weight: 600;\n\tfont-family: \"Poppins\", sans-serif;\n\tpadding: 12px 18px;\n\tborder-radius: 50px;\n\t-webkit-border-radius: 50px;\n\t-moz-border-radius: 50px;\n\t-ms-border-radius: 50px;\n\t-o-border-radius: 50px;\n\tbox-shadow: 0px 4px 4px rgba(0, 0, 0, 0.15);\n\tcursor: pointer;\n\theight: auto !important;\n}\n\n.InfoStep_otr .existing_btn,\n.InfoStep_otr .existing_btn:hover {\n\tbackground: var(--primary-color) !important;\n\tborder: 1px solid var(--primary-color) !important;\n\tcolor: var(--white-color) !important;\n}\n\n.InfoStep_otr .new_btn,\n.InfoStep_otr .new_btn:hover {\n\tborder: 1px solid var(--info-button-bg) !important;\n\tbackground: var(--info-button-bg) !important;\n\tcolor: var(--black-color) !important;\n}\n\n.pac-container {\n\tz-index: 100000000000000000;\n}\n\n.address-autofill {\n\twidth: -webkit-fill-available;\n\t/* height: 45px; */\n\tpadding: 14px 14px 12px 14px;\n\tfont-family: Verdana, sans-serif;\n\tborder-color: #d9d9d9;\n\tmin-width: 0;\n\tbackground-color: #ffffff;\n\tbackground-image: none;\n\tborder-width: 1px;\n\tborder-style: solid;\n\tborder-color: #d9d9d9;\n\tborder-radius: 6px;\n\ttransition: all 0.2s;\n\tcolor: rgba(0, 0, 0, 0.88);\n\tfont-size: 14px;\n\tline-height: 1.5714285714285714;\n}\n\n.address-autofill:focus-within {\n\tborder-color: var(--blue-input-border) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
